
















import {Component, Prop, Vue} from 'vue-property-decorator';
import {QDialog} from 'quasar';

@Component({
	components: {}
})
export default class SlideUpModal extends Vue {
	@Prop({default: ''})
	bodyClass!: string;

	show() {
		(this.$refs.dialog as QDialog).show();
	}

	hide() {
		(this.$refs.dialog as QDialog).hide();
	}

	onDialogHide() {
		this.$emit('hide');
	}

	onOK(payload: any) {
		this.$emit('ok', payload);
		this.hide();
	}

	onCancel() {
		// we just need to hide dialog
		this.hide();
	}
}
